import './_bootstrap';
import { App } from './_vue'
import Vue from 'vue'
import VueFlatpickr from 'vue-flatpickr-component'
import handlesPostcodeFind from "./mixins/handlesPostcodeFind";

Vue.use(VueFlatpickr);

window.app = new App({
    el: '#app',
    mixins: [handlesPostcodeFind]
})
